import { Component, OnInit } from '@angular/core';
import { ConfigService, UserService } from './shared';
import { Router, ActivatedRoute } from '@angular/router';

/**
 * This component really has no view, it just simply routes the user to login or if already logged in, to a different page.
 */
@Component({
    template: '',
    standalone: false
})
export class LoginComponent implements OnInit {
  // todo set this to what we really want it to be
  private defaultPage = 'sponsor/manage/';

  returnUrl = '';

  constructor(
    private userService: UserService,
    private configService: ConfigService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const config = this.configService.getConfig();

    // already have a / in the appRoot
    this.returnUrl = `${config.appRoot}${this.defaultPage}`;

    // check if there's a specific page we really want
    if (this.route.snapshot.queryParams['returnUrl']) {
      this.returnUrl = `${config.appRoot}${
        this.route.snapshot.queryParams['returnUrl']
      }`;
    }

    // TODO might need to redo the isLoggedIn() to something like isLoggedInByuiAccount() and isLoggedInLdsAccount() or something...
    if (this.userService.isLoggedIn()) {
      this.router.navigate([this.defaultPage]);
    } else {
      window.location.href = `${config.appRoot}support/login?redirectUrl=${
        this.returnUrl
      }`;
    }
  }
}
